var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guidetake"},[_c('crumbs',{staticClass:"crumbs",attrs:{"location":_vm.location},on:{"exportCls":_vm.exportCls}}),_c('div',{staticClass:"box"},[_c('guidelt',{attrs:{"type":6}}),_c('guidecnt6')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }